module.exports = __webpack_public_path__ + "img/rpi4.19678de.gif";